import { createContext, useContext } from 'react'
import { stores } from './stores'

const storesContext = createContext(stores)

export const useStores = () => useContext(storesContext)
